import { Utilities as utilities } from '@truckdown/framework';
import { AppType } from './AppType';
import { DeviceType } from './DeviceType';

export class UserContextClientModel {
    appType: AppType = AppType.Unknown;
    deviceType: DeviceType = DeviceType.Desktop;
    device: string = '';
    client: string = '';
    version: string = '';
    address: string = '';
    conAddress: string = '';
    userAgent: string = '';
    crawler: string = '';
}

export class UserContextSystemModel {
    name: string = '';
    httpUrl: string = '';
    httpsUrl: string = '';
}

export class UserContextUserModel {
    id: string = '';
    accountId: string = '';
    accountNumber: number = 0;
    username: string = '';
    claims: string[] = [];
}

export class UserContextModel {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, '_id', '');
            this.instance = utilities.json.getStringValue(json, 'instance', '');
            this.input = utilities.json.getStringValue(json, 'ir', '');
            this.parentId = utilities.json.getStringValue(json, 'parentId');

            this.start = utilities.json.getDateValue(json, 'start', new Date(0));
            this.status = utilities.json.getNumberValue(json, 'status', 0);

            if (json.hasOwnProperty('client') && json['client'] && json['client'] !== null) {
                this.client = json['client'] as UserContextClientModel;
            }
            if (json.hasOwnProperty('system') && json['system'] && json['system'] !== null) {
                this.system = json['system'] as UserContextSystemModel;
            }
            if (json.hasOwnProperty('user') && json['user'] && json['user'] !== null) {
                this.user = json['user'] as UserContextUserModel;
            }
            if (json.hasOwnProperty('settings') && json['settings'] && json['settings'] !== null) {
                this.settings = json['settings'] as { [key: string]: string };
            }

            if (this.settings.hasOwnProperty('parent') && utilities.data.isString(this.settings['parent'])) {
                this.parentId = this.settings['parent'];
            }
        }
    }

    id: string = '';
    instance: string = '';
    input: string = '';
    parentId: string | null = null;
    start: Date = new Date(0);
    status: number = 0;

    client: UserContextClientModel = new UserContextClientModel();
    system: UserContextSystemModel = new UserContextSystemModel();
    user: UserContextUserModel | null = null;
    settings: { [key: string]: string } = {};

}